module.exports = __webpack_public_path__ + "static/HappyFeet-04-8603e900f17472141c5ae362e7900404.jpg";